import {reExportedColors} from '../1elements'
import SubCollapseForCard from './SubCollapseForCard'

const SubSubCollapseForCard = ({header, dataCount, children}) => {
    return (
        <SubCollapseForCard header={header} dataCount={dataCount} sx={{
            background: reExportedColors.LIGHT_GREY,
            '& .MuiListSubheader-root': {
                lineHeight: '40px',
                padding: '0 16px 0 30px'
            },
            '& .MuiCollapse-root': {
                background: reExportedColors.WHITE,
                paddingLeft: '60px'
            },
            '& > *': {
                paddingLeft: '20px'
            }
        }}>
            {children}
        </SubCollapseForCard>
    )
}

export default SubSubCollapseForCard
